import { Link as ChakraLink, Stack } from "@chakra-ui/react";
import Link from "next/link";
import { MAIN_ROUTES } from "@/constants/routes";
import { Text } from "@/elements";

const LinkComponent = ({ href, label }: { href: string; label: string }) => {
  return (
    <ChakraLink
      as={Link}
      color="primary.200"
      fontSize={"1.2rem"}
      fontWeight={500}
      href={href}
      textDecor={"underline"}
      textDecorationColor={"#F9AF18"}
      textDecorationThickness={"1px"}
      textUnderlineOffset={"4px"}
    >
      {label}
    </ChakraLink>
  );
};

export const FAQ_LIST = {
  items: [
    {
      title: "What is the difference between Private Cloud and POC Cloud?",
      content:
        "Private Cloud is designed for secure, long-term infrastructure, while POC Cloud is optimized for testing and short-term innovation.",
    },
    {
      title: "How does Private Cloud improve security?",
      content:
        "It offers dedicated resources, encryption, and compliance controls, ensuring data protection and privacy.",
    },
    {
      title: "What are the benefits of POC Cloud for businesses?",
      content:
        "It allows cost-effective, real-time testing of new technologies without disrupting production environments.",
    },
    {
      title: "Can I migrate existing workloads to Onemind's Cloud Services?",
      content:
        "Yes! We offer seamless cloud migration, ensuring minimal downtime and maximum performance.",
    },
    {
      title: "What industries benefit from Private Cloud?",
      content:
        "Finance, healthcare, telecom, and enterprises requiring high security, scalability, and compliance.",
    },
    {
      title: "How does Onemind ensure cloud reliability?",
      content:
        "Our cloud solutions have high availability, failover mechanisms, and 24/7 support to ensure business continuity.",
    },
    {
      title: "Can I customize my Private Cloud setup?",
      content:
        "Absolutely! We offer tailored infrastructure, networking, and security configurations to meet specific business needs.",
    },
    {
      title: "How does POC Cloud support DevOps teams?",
      content:
        "It provides real-time, scalable test environments for CI/CD pipelines, automation, and deployment validation.",
    },
    {
      title: "Is data encrypted in Onemind's Cloud Services?",
      content: "Yes, we offer end-to-end encryption for data at rest and in transit.",
    },
    {
      title: "How can I get started with Onemind's Cloud Services?",
      content: (
        <Stack>
          <Text variant={"body2"}>
            Contact us today to explore customized cloud solutions tailored to your
            business needs!
          </Text>
          <LinkComponent
            href={MAIN_ROUTES.BOOK_A_CONSULTATION}
            label={"Talk to an Expert"}
          />
        </Stack>
      ),
    },
  ],
};
